import {
  Avatar,
  Button,
  Form,
  Input,
  List,
} from 'antd';
import React, { useEffect, useState } from 'react';
import {
  related_comments_ticket_path,
  ticket_comments_path,
} from 'js-routes/generated/routes';
import useErrors from 'hooks/forms/useErrors';
import { string, shape, number } from 'prop-types';
import CommentList from './CommentList';
import useSubmitForm from './hooks/useSubmitForm';
import useUpdateComment from './hooks/useUpdateComment';
import useEmbedImage from './hooks/useEmbedImage';

const { TextArea } = Input;

const TicketComments = ({
  ticketId = null,
  currentUserInfo = {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
  },
}) => {
  const [form] = Form.useForm();
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsLoading(true);
    fetch(related_comments_ticket_path(ticketId))
      .then((response) => response.json())
      .then((data) => {
        setComments(data.comments);
        setIsLoading(false);
      });
  }, [ticketId]);

  const {
    handleError,
    clearErrors,
  } = useErrors();

  const { handleUpdateComment } = useUpdateComment({ setComments });

  const { handlePaste, handleDragOver, handleDrop } = useEmbedImage({
    ticketId, form, fieldName: 'content',
  });

  const {
    isFormSending,
    handleSubmitForm,
    submitButtonName,
  } = useSubmitForm({
    form,
    formUrl: ticket_comments_path(),
    clearErrors,
    handleError,
    setComments,
  });

  return (
    <>
      {(isLoading || comments.length > 0) && (
        <CommentList
          ticketId={ticketId}
          comments={comments}
          loading={isLoading}
          onUpdate={handleUpdateComment}
        />
      )}

      <List.Item>
        <div className="ticket-comments-form">
          <Avatar
            src={currentUserInfo.avatarUrl}
            size={40}
          />

          <div className="ticket-comments-form__editor">
            <Form
              component={false}
              form={form}
              layout="vertical"
              onFinish={handleSubmitForm}
              /* eslint-disable camelcase */
              initialValues={{
                author_type: currentUserInfo.type,
                author_id: currentUserInfo.id,
                ticket_id: ticketId,
              }}
              /* eslint-enable camelcase */
              disabled={isFormSending}
            >
              <Form.Item name="ticket_id" hidden>
                <Input type="hidden" />
              </Form.Item>

              <Form.Item name="author_type" hidden>
                <Input type="hidden" />
              </Form.Item>

              <Form.Item name="author_id" hidden>
                <Input type="hidden" />
              </Form.Item>

              <Form.Item
                name="content"
                rules={[{ required: true, message: 'Please enter your comment' }]}
                className="ticket-comments-form__content-field"
              >
                <TextArea
                  autoSize={{ minRows: 4 }}
                  placeholder="Add a comment..."
                  onPaste={handlePaste}
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragOver}
                  onDrop={handleDrop}
                />
              </Form.Item>

              <div className="ticket-comments-form__footer">
                <Button
                  type="primary"
                  loading={isFormSending}
                  onClick={() => form.submit()}
                  size="small"
                >
                  {submitButtonName}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </List.Item>

    </>
  );
};

TicketComments.propTypes = {
  ticketId: number,
  currentUserInfo: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
  }),
};

export default TicketComments;
